export const EnOutOfOfficeStrings = {
  UPDATE_SUCCESS_MSG: "The Out of Office schedule has been updated successfully",
  DELETE_SUCCESS_MSG: "The Out of Office schedule has been removed successfully",

  OUT_OF_OFFICE_UNTIL: "Out of office until "
}
